module.exports = __webpack_public_path__ + "img/product-management.c1ff6062.png";